import { useEffect, useState } from 'react';

import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react';
import PropTypes from 'prop-types';

import { getAppConfig } from '../utilities';

const UnleashFlagProvider = ({ render, disableFlag, customFlag }) => {
  const [isUnleashHealthy, setIsUnleashHealthy] = useState(true);

  const isDisabled = useFlag(disableFlag);
  const isCustomFlag = useFlag(customFlag);
  const { flagsReady } = useFlagsStatus();

  const { url } = getAppConfig('unleashConfig');

  useEffect(() => {
    const getUnleashProxyHealth = async () => {
      try {
        await fetch(`${url}health`);
      } catch (error) {
        setIsUnleashHealthy(false);
      }
    };
    getUnleashProxyHealth();
  }, []);

  return (
    <>
      {render({
        isDisabled,
        flagsReady,
        isUnleashHealthy,
        ...(customFlag && { isCustomFlag })
      })}
    </>
  );
};

UnleashFlagProvider.propTypes = {
  disableFlag: PropTypes.string,
  render: PropTypes.func.isRequired,
  customFlag: PropTypes.string
};

UnleashFlagProvider.defaultProps = {
  disableFlag: '',
  customFlag: ''
};

export default UnleashFlagProvider;
